import { nanoid } from 'nanoid'
import { type ActionItem } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { type Campaign } from 'entities/Campaign'
import { CampaignDetailsModalContent } from './CampaignDetailsModalContent'

export const campaignDetailsAction = (item: Campaign): ActionItem => {
  const onAction = () => {
    modalStore.addModal({
      id: nanoid(),
      width: 540,
      position: 'right',
      type: ModalTypeList.DEFAULT,
      ModalContentProps: { item },
      ModalContent: () => <CampaignDetailsModalContent item={item} />,
      title: 'Details',
      pureContent: true,
      fullHeight: true,
    })
  }

  return {
    icon: 'eye',
    onAction,
    text: 'Details',
  }
}
